/* eslint-disable import/no-unresolved */
// Styles - webpack will handover the styles to the jekyll assets folder
import '_scss/main.scss'

import smoothscroll from 'smoothscroll-polyfill'

// JS
import dialog from '_components/dialog'
import footer from '_components/footer'
import bg from '_components/bg'
import text from '_components/text'

// DOMContent loaded
(() => {
  // init modules if they are in the page
  dialog()
  footer()
  bg()
  text()
  smoothscroll.polyfill()
})()
